/**
 * edgeFunctionUrl.ts
 * Single source of truth for ALL Supabase edge function URLs.
 * Every edge function call in the frontend MUST go through this.
 */

import { SUPABASE_ANON_KEY } from "@/lib/supabaseClient";

// Hardcoded to the real project URL
const SUPABASE_URL = "https://vankfsmglinsfmjijpsc.supabase.co";

/** Base URL for all Supabase edge functions */
const BASE_URL = `${SUPABASE_URL}/functions/v1`;

export const EDGE_FUNCTIONS = {
  submitForm: `${BASE_URL}/submit-form`,
  submitReview: `${BASE_URL}/submit-review`,
  getSiteContent: `${BASE_URL}/get-site-content`,
  saveSiteContent: `${BASE_URL}/save-site-content`,
  uploadImage: `${BASE_URL}/upload-image`,
} as const;

/**
 * Returns the standard headers required for ALL Supabase edge function calls.
 * The Supabase gateway requires a valid Authorization header (anon key JWT)
 * or it returns 401 before the request ever reaches your edge function.
 */
export function getEdgeFunctionHeaders(): Record<string, string> {
  return {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${SUPABASE_ANON_KEY}`,
  };
}
